export default __webpack_public_path__ + "static/media/icon_chevron-down.003dbf52.svg";